import React from 'react';
import './MainPage.css'
import Events from '../Events/Events'

function MainPage() {
    return (
        <div className='MainPage'>
            <Events />
        </div>
    )
}

export default MainPage